import en from './en'

export const messages = {
  en,
}
